import {PurchaseApprovalStatus} from "./PurchaseApprovalStatus";

export const PurchaseApprovalStatusNames: Record<PurchaseApprovalStatus, string> = {
  [PurchaseApprovalStatus.PENDING_REVIEW]: "Pendiente Revision",
  [PurchaseApprovalStatus.ERROR]: "Erronea",
  [PurchaseApprovalStatus.VALIDATED]: "Correcta",
};
